import Notify from "./notifyActions";

export const DEVICE_LIST = "DEVICE_LIST";

export const deviceList = pager => ({
  type: DEVICE_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: "DeviceList",
      method: "POST",
      data: pager
    }
  }
});

export const DEVICE_ADD = "DEVICE_ADD";
export const DEVICE_ADD_SUCCESSFULL_TOAST = "device_add_successfull_toast";
export const DEVICE_ADD_UNSUCCESSFULL_TOAST = "device_add_unsuccessfull_toast";
export const DEVICE_ADD_DUPLICATE_TOAST = "device_add_duplicate_toast";

export const addDevice = (data, pager) => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_ADD,
      payload: {
        request: {
          mode: "no-cors",
          url: "Device",
          method: "POST",
          data: {
            request: data
          }
        }
      }
    }).then(response => {
      if (response.payload.data.success) {
        dispatch(Notify.success(DEVICE_ADD_SUCCESSFULL_TOAST));
        dispatch(deviceList(pager));
      } else {
        if (response.payload.data.errors === "error_duplicatedevice") {
          dispatch(Notify.error(DEVICE_ADD_DUPLICATE_TOAST));
        } else {
          dispatch(Notify.error(DEVICE_ADD_UNSUCCESSFULL_TOAST));
        }
      }
    });
  };
};

export const DEVICE_DELETE = "DEVICE_DELETE";
export const DEVICE_DELETE_SUCCESSFULL_TOAST =
  "device_delete_successfull_toast";
export const DEVICE_DELETE_UNSUCCESSFULL_TOAST =
  "device_delete_unsuccessfull_toast";

export const deleteDevice = (id, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Device?deviceId=${id}`,
            method: "DELETE"
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(DEVICE_DELETE_SUCCESSFULL_TOAST));
          dispatch(deviceList(pager));
          resolve(response.payload.data.success);
        } else {
          dispatch(Notify.error(DEVICE_DELETE_UNSUCCESSFULL_TOAST));
          resolve(response.payload.data.success);
        }
      });
    });
  };
};

export const DEVICE_INFO = "DEVICE_INFO";
export const deviceInfo = deviceId => ({
  type: DEVICE_INFO,
  payload: {
    request: {
      mode: "no-cors",
      url: `device/${deviceId}`,
      method: "GET"
    }
  }
});

export const ADAPTER_ASSET_LIST = "ADAPTER_ASSET_LIST";
export const adapterAssetList = search => ({
  type: ADAPTER_ASSET_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: search ? `adapter-list?search=${encodeURIComponent(search)}` : "adapter-list",
      method: "GET"
    }
  }
});

export const ADAPTER_ASSET_INFO = "ADAPTER_ASSET_INFO";
export const adapterAssetInfo = serialNo => ({
  type: ADAPTER_ASSET_INFO,
  payload: {
    request: {
      mode: "no-cors",
      url: `adapter/${encodeURIComponent(serialNo)}`,
      method: "GET"
    }
  }
});

export const ADAPTER_ASSET_DELETE = "ADAPTER_ASSET_DELETE";
export const ADAPTER_ASSET_DELETE_SUCCESSFUL_TOAST =
  "adapter_delete_successful_toast";
export const ADAPTER_ASSET_DELETE_UNSUCCESSFUL_TOAST =
  "adapter_delete_unsuccessful_toast";

export const deleteAdapterAsset = id => {
  return dispatch => {
    return dispatch({
      type: ADAPTER_ASSET_DELETE,
      payload: {
        request: {
          mode: "no-cors",
          url: `adapter/${id}`,
          method: "DELETE"
        }
      }
    }).then(response => {
      const success = !!(response.payload.data && response.payload.data.success);

      if (success) {
        dispatch(Notify.success(ADAPTER_ASSET_DELETE_SUCCESSFUL_TOAST));
        dispatch(adapterAssetList());
      } else {
        dispatch(Notify.error(ADAPTER_ASSET_DELETE_UNSUCCESSFUL_TOAST));
      }

      return success;
    });
  };
};

export const DEVICE_LOCK_STATUS = "DEVICE_LOCK_STATUS";
export const DEVICE_LOCK_TOAST = "device_lock_toast";
export const DEVICE_UNLOCK_TOAST = "device_unlock_toast";
export const updateDeviceLockStatus = (deviceId, status) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_LOCK_STATUS,
        payload: {
          request: {
            mode: "no-cors",
            url: `editdevice/ToggleIsLocked/${deviceId}`,
            method: "PUT"
          }
        }
      }).then(response => {
        dispatch(Notify.success(!status ? DEVICE_LOCK_TOAST : DEVICE_UNLOCK_TOAST));
        dispatch(deviceInfo(deviceId));
        resolve(response.payload.data.success);
      });
    });
  };
};

export const DEVICE_STOLEN_TOAST = "device_stolen_toast";
export const DEVICE_STOLEN_STATUS = "DEVICE_STOLEN_STATUS";
export const DEVICE_STOLEN_STATUS_REVERT_TOAST = "revert_device_stolen_toast";
export const updateDeviceStolenStatus = (deviceId, iSstolen) => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_STOLEN_STATUS,
      payload: {
        request: {
          mode: "no-cors",
          url: `editdevice/ToggleIsStolen/${deviceId}`,
          method: "PUT"
        }
      }
    }).then(response => {
      if (iSstolen) {
        dispatch(Notify.success(DEVICE_STOLEN_STATUS_REVERT_TOAST));
      } else {
        dispatch(Notify.success(DEVICE_STOLEN_TOAST));
      }
      dispatch(deviceInfo(deviceId));
    });
  };
};

export const DEVICE_RESET_PIN_TOAST = "device_reset_pin_toast";
export const DEVICE_RESET_PIN = "DEVICE_RESET_PIN";
export const resetDevicePin = (deviceId) => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_RESET_PIN,
      payload: {
        request: {
          mode: "no-cors",
          url: `editdevice/ResetPin/${deviceId}`,
          method: "PUT"
        }
      }
    }).then(response => {
        dispatch(Notify.success(DEVICE_RESET_PIN_TOAST));
        dispatch(deviceInfo(deviceId));
    });
  };
};

export const DEVICE_VNC = "DEVICE_VNC";
export const deviceVNC = deviceId => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_VNC,
      payload: {
        request: {
          mode: "no-cors",
          url: `VNCViewer`,
          method: "GET"
        }
      }
    }).then(response => {
      let url = response.payload.data;
      if (url) {
        window.open(url, "_blank");
      }
    });
  };
};

export const SEARCH_DEVICE_DETAILS = "SEARCH_DEVICE_DETAILS";
export const STORE_DEVICE_DETAILS = "STORE_DEVICE_DETAILS";
export const DEVICE_NOT_FOUND = "device_not_found";
export const searchDeviceDetails = deviceId => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SEARCH_DEVICE_DETAILS,
        payload: {
          request: {
            mode: "no-cors",
            url: "DeviceDetails",
            method: "POST",
            data: {
              deviceserialno: deviceId
            }
          }
        }
      }).then(response => {
        if (
          response &&
          response.payload &&
          response.payload.data &&
          response.payload.data.errors == "error_nodevice"
        ) {
          dispatch({type: STORE_DEVICE_DETAILS, payload: {}});
          dispatch(Notify.error(DEVICE_NOT_FOUND));
          return;
        }
        if (response && response.payload && response.payload.data) {
          dispatch({
            type: STORE_DEVICE_DETAILS,
            payload: response.payload.data
          });
        }
      });
    });
  };
};

export const RESET_DEVICE_DETAILS = "RESET_DEVICE_DETAILS";
export const resetDeviceDetails = () => ({
  type: RESET_DEVICE_DETAILS
});

export const RESET_ADAPTER_ASSET_DETAILS = "RESET_ADAPTER_ASSET_DETAILS";
export const resetAdapterAssetDetails = () => ({
  type: RESET_ADAPTER_ASSET_DETAILS
});

export const DEVICE_TYPE_LIST = "DEVICE_TYPE_LIST";
export const deviceTypeList = () => ({
  type: DEVICE_TYPE_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: `SystemDeviceType`,
      method: "GET"
    }
  }
});

export const DEVICE_CREATE_RMA = "DEVICE_CREATE_RMA";
export const DEVICE_CREATE_RMA_SUCCESS_TOAST = "device_create_rma_success_toast";
export const DEVICE_CREATE_RMA_ERROR_TOAST = "device_create_rma_error_toast";

export const createDeviceRma = (deviceId, data) => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_CREATE_RMA,
      payload: {
        request: {
          mode: "no-cors",
          url: `device/${deviceId}/create-rma`,
          method: "POST",
          data: data
        }
      }
    }).then(response => {
      if (response.payload.data && response.payload.data.success) {
        dispatch(Notify.success(DEVICE_CREATE_RMA_SUCCESS_TOAST));
      } else {
        dispatch(Notify.error(DEVICE_CREATE_RMA_ERROR_TOAST));
      }
    });
  };
};
